import { Route, Routes } from 'react-router-dom';
import { Consult } from '../pages/Consult/Consult';
import { ConsultationData } from '../pages/ConsultationData/ConsultationData';
import { Login } from '../pages/Login/Login';
import { Home } from '../pages/Home/Home';
import { Register } from '../pages/Register/Register';
import Dashboard from '../pages/Dashboard/Dashboard';
import Report from '../pages/Report/Report';
import { Informacao } from '../pages/Informacao';
import Reset from '../pages/ResetPassword/Reset';
import RecoveryCode from '../pages/ResetPassword/RecoveryCode';
import DefineNewPassword from '../pages/ResetPassword/DefineNewPassword';
import Detailing from '../pages/Detailing/Detailing';
import { PrivateRoute } from './privateRoutes';

export function Router() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/reset-password" element={<Reset />} />
      <Route path="/recovery-code" element={<RecoveryCode />} />
      <Route path="/define-new-password" element={<DefineNewPassword />} />
      <Route
        path="/home"
        element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/detailing"
        element={
          <PrivateRoute>
            <Detailing />
          </PrivateRoute>
        }
      />
      <Route
        path="/monitoramento/acessos-consolidados"
        element={
          <PrivateRoute>
            <Informacao />
          </PrivateRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PrivateRoute>
            <Register />
          </PrivateRoute>
        }
      />
      <Route
        path="/consult"
        element={
          <PrivateRoute>
            <Consult />
          </PrivateRoute>
        }
      />
      <Route
        path="/report"
        element={
          <PrivateRoute>
            <Report />
          </PrivateRoute>
        }
      />
      <Route
        path="/consult/devedor/:cpf"
        element={
          <PrivateRoute>
            <ConsultationData />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}
